<template>
    <div class="frmegeszsegkartya_formcont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>
        <GrcDialog_KartyaAktivalas ref="Dialog_KartyaAktivalas"></GrcDialog_KartyaAktivalas>



        <div class="frmegeszsegkartya_cont" v-show="(InitDone)&&(LIST.length>0)">
            <div v-for="(item, index) in LIST" :key="index" class="frmegeszsegkartya_item">
                <div class="frmegeszsegkartya_itemcol1">
                    <b>{{item.Kartyaszam}}</b>
                    <br>{{item.KartyaNev}}
                    <br><span v-show="item.Lejarat!='-'">Lejárat: {{item.Lejarat}}</span>
                </div>
                <div class="frmegeszsegkartya_itemcol2">
                    <span :class="[item.AktivalasEngedely==1?'frmegeszegkartya_status1':item.ZarolasEngedely==1?'frmegeszegkartya_status2':'frmegeszegkartya_status3']">{{item.StatuszNev}}</span>
                    <br>{{item.TipusNev}}
                    <br>
                    <span @click="DoAction(index,1)" class="cms_linkbutton cms_linkbutton_GREEN_FULL" style="margin: 4px 4px 4px 0px;" v-show="item.AktivalasEngedely==1">Aktiválom</span>
                    <span @click="DoAction(index,0)" class="cms_linkbutton cms_linkbutton_RED_FULL" style="margin: 4px 4px 4px 0px;" v-show="item.TiltasEngedely==1">Letiltom</span>
                </div>
            </div>
        </div>

        <div class="frmegeszsegkartya_cont" v-show="(InitDone)&&(LIST.length==0)" v-html="infotext_nincs_rekord">

        </div>



    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCheckboxMobile from '../GrcComponents/GrcCheckboxMobile.vue'
import GrcDialog_KartyaAktivalas from '../GrcComponents/GrcDialog_KartyaAktivalas.vue'


export default {
  name: 'frmegeszsegkartya',
  components: {
      GrcText,
      GrcNum,
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCheckboxMobile,
      GrcDialog_KartyaAktivalas
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmEgeszsegkartya_",

          InitDone:false,  
          LIST:[],

          infotext_nincs_rekord:"",

      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmEgeszsegkartya", pCompName);
    },

    SetLang()
    {
        this.infotext_nincs_rekord = this.GetTextBookItem("infotext_nincs_rekord");
        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },

    async DoAction(pIndex, pActionID)
    {
      let infotext = "";

      //infotext = "<b>"+this.LIST[pIndex].Kartyaszam+"</b><br><br>";
      

      if (pActionID == 1)
      {
        infotext = infotext + "Az aktiváláshoz kérjük adja meg a kártyaszám utolsó 3 számjegyét:";
      }
      else
      {
        infotext = infotext + "<b>Biztosan le szeretné tiltani a kártyát?</b>"
        +"<br><br>" + this.LIST[pIndex].Kartyaszam
        +"<br>" + this.LIST[pIndex].KartyaNev;
      }


      var DialogResult = "";
      var CardNumLast3 = "";

        var p = grccomp_dialog_yesno_GetDefaults("Megerősítés", infotext);             
        p.height = 250;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 320; }

        if (pActionID == 1)
        {
            //var CN = this.LIST[pIndex].Kartyaszam.replace(/[^0-9]/g, '');
            var CN = this.LIST[pIndex].Kartyaszam.replace(" XXX", '');

            await this.$refs.Dialog_KartyaAktivalas.ShowDialog(p,CN).then(res => { DialogResult = res.btnres; CardNumLast3 = res.last3char });        
        }
        else
        {
            await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });        
        }
        

        if (DialogResult != "YES") { return; }

        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSESSIONID: "[APPSESSIONID]",
            iKartyaID: this.LIST[pIndex].id,
            iActionID: pActionID,
            sLast3: CardNumLast3
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "DoAction", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.LIST = Q.RESULT;

    },

      async Init()
      {
        this.InitDone = false;

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.LIST = Q.RESULT;

        this.InitDone = true;

      },

    async ShowDialog(pTitle, pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert(pTitle, pText).then(res => { DialogResult = res; });
        
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


